export const pushToDataLayer = (data = {}): void => {
  if (import.meta.client && window) {
    const dataLayer = (window as any).dataLayer || []
    dataLayer.push(data)
  }
}

export const getRandomVariant = (variantCount: number): number => {
  // getRandomVariant(4) returns 0, 1, 2 or 3
  if (variantCount <= 0) {
    throw new Error('Variant count must be greater than 0')
  }

  return Math.floor(Math.random() * variantCount)
}
